<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">运费单价设置（距离）</h3>

    <div class="table-container">
      <el-row style="padding-bottom: 10px">
        <el-button type="primary" size="mini" @click="saveData">保存</el-button>
      </el-row>

      <TableCommon title="明细信息" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="add" tip="增加" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #productCode="{row}">
            <wly-input
              v-model="row.productCode"
              size="mini"
              placeholder="请选择产品"
              input-type="product"
              :query-params="{ customerCode }"
              @enter="handleEnter(...arguments,row)"
              @handleSuffixClick="openDialog($event, row)"
            />
          </template>
          <template #lt300Price="{row}">
            <el-input v-model="row.lt300Price" size="mini" />
          </template>
          <template #gt300Lt500Price="{row}">
            <el-input v-model="row.gt300Lt500Price" size="mini" />

          </template>
          <template #gt500Lt1000Price="{row}">
            <el-input v-model="row.gt500Lt1000Price" size="mini" />

          </template>
          <template #le1000Price="{row}">
            <el-input v-model="row.le1000Price" size="mini" />
          </template>
          <template #validate="{row}">
            <el-date-picker
              v-model="row.validate"
              size="mini"
              type="date"
              value-format="yyyy-MM-dd"
            />
          </template>
        </vxe-grid>
      </TableCommon>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="产品选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <product-select ref="ProductSelect" :query-params="{customerCode}" :is-auth="true" :is-radio="false" />

      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import { apiLogisticSagingSaveDistancePrices } from '@/api/applyForGoods/logisticsAbnormal'

export default {
  name: 'freight-setting-trunk',
  components: {
    ProductSelect
  },
  data() {
    return {
      currentRow: {},
      customerCode: '',
      showDialog: false,
      gridOptions: {
        data: [
        ],
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 },
          { field: 'productCode', title: '产品', slots: { default: 'productCode' }},
          { field: 'lt300Price', title: '运费单价(300KM以内)', slots: { default: 'lt300Price' }},
          { field: 'gt300Lt500Price', title: '运费单价(300-500KM)', slots: { default: 'gt300Lt500Price' }},
          { field: 'gt500Lt1000Price', title: '运费单价(500-1000KM)', slots: { default: 'gt500Lt1000Price' }},
          { field: 'le1000Price', title: '运费单价(>1000KM)', slots: { default: 'le1000Price' }},
          { field: 'validate', title: '生效日', slots: { default: 'validate' }}
        ]
      }
    }
  },
  created() {
    // this.customerCode = this.$store.getters.role.USER_BP
    this.customerCode = '50000215'
  },
  methods: {
    async saveData() {
      const res = await apiLogisticSagingSaveDistancePrices(this.gridOptions.data)
    },
    insertData() {
      const data = {
        productCode: '',
        lt300Price: '',
        gt300Lt500Price: '',
        gt500Lt1000Price: '',
        le1000Price: '',
        validate: ''
      }
      this.gridOptions.data.unshift(data)
    },
    removeData() {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (!data.length) return this.$message.warning('请选择有效数据！')
      const idx = data.map(v => v._X_ID)
      this.gridOptions.data = this.gridOptions.data.filter(v => !idx.includes(v._X_ID))
    },
    openDialog(e, row) {
      this.currentRow = row
      this.showDialog = true
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return

      switch (type) {
        case 'product':
          if (row) {
            this.currentRow = row
            this.XID = row._X_ID
          }
          // 判断选择产品是否重复
          if (this.gridOptions.data.findIndex(v => v.productCode === data.productCode) > -1) {
            return this.$message.warning('请勿选择重复产品！')
          }
          this.currentRow.productCode = data.PRODUCT_ID
          this.currentRow.productName = data.SHORT_TEXT
          break
      }
    },
    async submitHandle() {
      const res = await this.$refs.ProductSelect.submitForm()
      if (res.length && res.length > 1) {
        const rows = []
        res.forEach(item => {
          const row = {
            ...this.currentRow
          }
          row.productCode = item.PRODUCT_ID
          row.productName = item.SHORT_TEXT
          rows.push(row)
        })
        const index = this.gridOptions.data.findIndex(v => v._X_ID === this.currentRow._X_ID)
        this.gridOptions.data.splice(index, 1, ...rows)
      } else if (res.length === 1) {
        this.currentRow.productCode = res[0].PRODUCT_ID
        this.currentRow.productName = res[0].SHORT_TEXT
      }
      this.showDialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/freightSettingMileage.vue